import { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { cx } from '@emotion/css';

import { ReactComponent as AppointmentImage } from '../../../../assets/images/appointment/active-appointment.svg';
import { Modal } from '../../../common';
import { Button } from '../../../common/button-new';
import { v2026PP12553 } from '../../../../constants/veeva';
import { convertDateToUIString } from '../../../../utils/date/convert-date-to-string';
import { ActiveAppointmentModalProps } from './active-appointment-modal.models';
import { useStyles } from './active-appointment-modal.styles';
import { getServiceLabelId } from '../../../../utils';

export const ActiveAppointmentModal = ({
  appointmentType, date, onView, onClose, ...props
}: ActiveAppointmentModalProps): JSX.Element => {
  const classes = useStyles();
  const intl = useIntl();

  const serviceLabel = intl.formatMessage({ id: getServiceLabelId(appointmentType) });
  const formattedDate = convertDateToUIString(date) ?? '';

  const handleView = useCallback((): void => {
    onClose?.();
    onView();
  }, [onClose, onView]);

  return (
    <Modal
      {...props}
      onClose={onClose}
      propsPaperStyles={classes.paper}
      propsContentStyles={classes.content}
      veevaNumber={v2026PP12553}
      isVeevaSmall
      content={(
        <>
          <h2 className={cx('title-medium', classes.title)} data-testid="active-appointment-title">
            {intl.formatMessage(
              { id: 'activeAppointmentModal.title' },
              { service: serviceLabel, date: formattedDate },
            )}
          </h2>
          <AppointmentImage className={classes.image} aria-hidden="true" />
          <p className={classes.description} data-testid="active-appointment-description">
            <FormattedMessage id="activeAppointmentModal.disclaimer" />
          </p>
          <Button
            testId="active-appointment-view-button"
            onClick={handleView}
            style="dark"
          >
            <FormattedMessage id="activeAppointmentModal.viewButton.label" />
          </Button>
        </>
      )}
    />
  );
};
